import { ChevronLeftIcon, ChevronRightIcon, XIcon } from "@/components/icons";
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from "@/components/kit";
import { cn } from "@/lib/utils";
import { AppImage } from "./AppImage";

export type ImageLightboxItem = {
  src: string;
  alt?: string;
};

type ImageLightboxDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  images: ImageLightboxItem[];
  index: number;
  onIndexChange: (index: number) => void;
  title?: string;
};

export function ImageLightboxDialog({
  open,
  onOpenChange,
  images,
  index,
  onIndexChange,
  title = "ຮູບອ້າງອິງ",
}: ImageLightboxDialogProps) {
  const current = images[index];
  const hasMultiple = images.length > 1;
  const hasPrev = index > 0;
  const hasNext = index < images.length - 1;

  if (!current) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className={cn(
          "top-0 left-0 flex h-dvh w-dvw max-w-none translate-x-0 translate-y-0 flex-col gap-0 rounded-none border-0 bg-black/95 p-0 shadow-none sm:max-w-none",
        )}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>

        <div className="flex items-center justify-between px-4 py-3">
          <p className="text-sm text-white/80">
            {hasMultiple ? `${index + 1} / ${images.length}` : title}
          </p>
          <DialogClose asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="text-white hover:bg-white/10 hover:text-white"
            >
              <XIcon />
              <span className="sr-only">ປິດ</span>
            </Button>
          </DialogClose>
        </div>

        <div className="relative flex min-h-0 flex-1 items-center justify-center px-12 pb-8 sm:px-16">
          {hasPrev ? (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="absolute left-2 text-white hover:bg-white/10 hover:text-white sm:left-4"
              onClick={() => onIndexChange(index - 1)}
            >
              <ChevronLeftIcon />
              <span className="sr-only">ຮູບກ່ອນໜ້າ</span>
            </Button>
          ) : null}

          <AppImage
            src={current.src}
            alt={current.alt ?? ""}
            fit="contain"
            className="max-h-[calc(100dvh-5rem)] w-full"
          />

          {hasNext ? (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="absolute right-2 text-white hover:bg-white/10 hover:text-white sm:right-4"
              onClick={() => onIndexChange(index + 1)}
            >
              <ChevronRightIcon />
              <span className="sr-only">ຮູບຖັດໄປ</span>
            </Button>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
